// extracted by mini-css-extract-plugin
export default {"termsAndConditions":"tos_termsAndConditions__6ePxx","tosWrapper":"tos_tosWrapper__2HclZ"};